import axios from "../libs/axios.lib";
import * as loginUtils from "../utils/login.utils";

export async function addVideosAPI(fd, overwrite = 0) {
	fd.set("overwrite", overwrite);

	const token = loginUtils.getUser().token;

	const { data } = await axios.post("videos/upload", fd, {
		headers: {
			Authorization: token,
			"Content-Type": "application/form-data",
		},
	});

	return data;
}

export async function abortVideosAPI(room_id) {
	const token = loginUtils.getUser().token;

	const fd = new FormData();
	fd.append("room_id", room_id);

	const { data } = await axios.post("videos/upload/abort", fd, {
		headers: {
			Authorization: token,
		},
	});

	return data;
}

export async function deleteVideosAPI(video_id) {
	const token = loginUtils.getUser().token;

	const { data } = await axios.delete(
		"videos/videos/" + encodeURIComponent(video_id),
		{
			headers: {
				Authorization: token,
			},
		}
	);

	return data;
}

export async function mergeBillboardsAPI(billboard_ids = [], selected_id) {
	const token = loginUtils.getUser().token;

	const { data } = await axios.post(
		"videos/billboards/merge",
		{
			billboard_ids,
			selected_id,
		},
		{
			headers: {
				Authorization: token,
			},
		}
	);

	return data;
}

export async function revertBillboardsAPI(billboards = []) {
	const token = loginUtils.getUser().token;

	const { data } = await axios.post(
		"videos/billboards/revert",
		{
			billboards,
		},
		{
			headers: {
				Authorization: token,
			},
		}
	);

	return data;
}

export async function addAssetInfoAPI(billboard_id = "", fd) {
	const token = loginUtils.getUser().token;

	const { data } = await axios.put(
		"videos/billboards/asset-info/" + billboard_id,
		fd,
		{
			headers: {
				Authorization: token,
				"Content-Type": "application/form-data",
			},
		}
	);

	return data;
}

export async function getAssetInfoAPI(billboard_id = "") {
	const token = loginUtils.getUser().token;

	const { data } = await axios.get(
		"videos/billboards/asset-info/" + billboard_id,

		{
			headers: {
				Authorization: token,
				"Content-Type": "application/form-data",
			},
		}
	);

	return data;
}

export async function deleteBillboardsAPI(billboard_ids = []) {
	const token = loginUtils.getUser().token;

	const { data } = await axios.post(
		"videos/billboards/delete",
		{
			billboard_ids,
		},
		{
			headers: {
				Authorization: token,
			},
		}
	);

	return data;
}

export async function getProcessedOutputAPI(video_id) {
	const token = loginUtils.getUser().token;

	const { data } = await axios.get(
		"videos/output/" + encodeURIComponent(video_id),
		{
			headers: {
				Authorization: token,
			},
		}
	);
	return data;
}

export async function getVidoesAPI() {
	const token = loginUtils.getUser().token;

	const { data } = await axios.get("videos/", {
		headers: {
			Authorization: token,
		},
	});

	return data;
}

export async function getVidoesbyId(videoIds) {
	const token = loginUtils.getUser().token;

	const { data } = await axios.post("videos/videos-by-ids", {
		video_ids: videoIds // Send array of IDs
	  }, {
		headers: { Authorization: token }
	  });
	
	  return data;
}

export async function updateBillboardsinBulk(video_ids, updateData) {
  const token = loginUtils.getUser().token;

  try {
    const { data } = await axios.patch(
      "videos/updateinbulk",  // Updated endpoint, no individual video_id in URL
      {
        video_ids, // Send array of video IDs
        ...updateData
      },
      {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json'
        }
      }
    );

    return data;
  } catch (error) {
    console.error('Error updating billboards in bulk:', error);
    throw error;
  }
}


export async function getFilenameByVideoId(video_id) {

	const token = loginUtils.getUser().token;

	const { data } = await axios.get("videos/filenamebyvideoid", {
		params:{video_id,},
		headers: {
			Authorization: token,

		},
	});

	return data;
}


export async function getVideoDetailsAPI(video_id_or_filename) {
	const token = loginUtils.getUser().token;

	const { data } = await axios.get("videos/details/" + encodeURIComponent(video_id_or_filename), {
		headers: {
			Authorization: token,
		},
	});

	return data;
}

export async function updateVideoMarketAPI(video_id, marketData) {
	const token = loginUtils.getUser().token;

	const { data } = await axios.put(
		"videos/markets/" + encodeURIComponent(video_id),
		marketData,
		{
			headers: {
				Authorization: token,
				"Content-Type": "application/json",
			},
		}
	);

	return data;
}

export async function getVideosWithLatLongs() {
	const token = loginUtils.getUser().token;

	const { data } = await axios.get("videos/with-lat-longs", {
		headers: {
			Authorization: token,
		},
	});

	return data;
}

export async function saveVideoCoordinates(video_id, coordinatesPayload) {
	const token = loginUtils.getUser().token;
  
	const { data } = await axios.post(
	  "videos/save-coordinates/" + encodeURIComponent(video_id),
	  coordinatesPayload,  // no wrapping in { coordinates }
	  {
		headers: {
		  Authorization: token,
		  "Content-Type": "application/json",
		},
	  }
	);
  
	return data;
  }
  
  export async function uploadZipVideosAPI(fd) {
	const token = loginUtils.getUser().token;

	const { data } = await axios.post("videos/uploadbulkinzip", fd, {
		headers: {
			Authorization: token,
			"Content-Type": "application/form-data",
		},
	});

	return data;
}

export async function uploadDriveFolderAPI(fd) {
  const token = loginUtils.getUser().token;

  const { data } = await axios.post("videos/uploadfromdrive", fd, {
    headers: {
      Authorization: token,
			// Let the browser set Content-Type for FormData (boundary included)
    },
  });

  return data;
}

// Temporary one-off upload for backend processing. This endpoint is intended
// to be accessed via a hidden URL and should not persist data on the frontend.
export async function uploadTempVideoAPI(fd) {
	const token = loginUtils.getUser().token;

	const { data } = await axios.post("videos/upload-temp", fd, {
		headers: {
			Authorization: token,
			// Do not set Content-Type for FormData here; let the browser/axios do it
		},
	});

	return data;
}
